import { render } from "./RegionsUpdate.vue?vue&type=template&id=3958a62b"
import script from "./RegionsUpdate.vue?vue&type=script&lang=js"
export * from "./RegionsUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__